import { observer } from 'mobx-react-lite'
import { makeTextFieldElement } from 'shared/ui/TextField'
import { CopyButtonTooltip } from 'shared/ui/Tooltip/variants'
import { Icon, Tooltip, Typography } from 'shared/ui'
import { type AssignNumberCommonStore } from 'entities/Phone'
import { NewInboxSelectOwner } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/NewInboxSelectOwner'
import { NewInboxName } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/NewInboxName'
import { NextButton } from '../NextButton/NextButton'
import styles from './styles.module.scss'

type INewInboxContentProps = {
  store: AssignNumberCommonStore
}

export const NewInboxPerNumber = observer(({ store }: INewInboxContentProps) => {
  const {
    newInboxPerNumberStore,
    nextButtonName,
    nextClick,
    loadingButton,
    hideSubmit,
    disabledButton,
  } = store
  const { items } = newInboxPerNumberStore

  return (
    <>
      <div className={styles.header}>
        <div className={styles.cell}>
          <Typography variant={'body-md-medium'} ariaLabel={'Inbox name'}>
            Inbox name
          </Typography>
          <Tooltip
            placement='top'
            label={
              <>
                The inbox name is <br /> automatically set to a phone <br /> number. Hover the info{' '}
                <br /> icon to view or copy the linked <br /> number.
              </>
            }
          >
            <Icon icon='question' fontSize={14} color={'var(--content-neutral-primary)'} />
          </Tooltip>
        </div>
        <div className={styles.cell}>
          <Typography variant={'body-md-medium'} ariaLabel={'Inbox owner'}>
            Inbox owner
          </Typography>
        </div>
      </div>
      <div>
        {items.map(({ number, newInboxStore }) => (
          <div key={number.id} className={styles.item}>
            <div className={styles.cell}>
              <NewInboxName
                newInboxStore={newInboxStore}
                rightActions={[
                  makeTextFieldElement({
                    element: (
                      <CopyButtonTooltip
                        textButton={number.number}
                        copiData={number.number}
                        title={'Linked number'}
                        width={195}
                      />
                    ),
                  }),
                ]}
              />
            </div>

            <div className={styles.cell}>
              <NewInboxSelectOwner
                newInboxStore={newInboxStore}
                size={'medium'}
                disabled={newInboxStore.membersWithoutObserver.length === 1}
              />
            </div>
          </div>
        ))}
      </div>

      {!hideSubmit && (
        <NextButton
          text={nextButtonName}
          disabled={disabledButton}
          loading={loadingButton}
          onClick={() => nextClick()}
        />
      )}
    </>
  )
})
